// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#greyscreen .v-btn__content{color:var(--branding-active-hex)!important}#greyscreen .unlink-bulb div{color:#fff!important}resourceName{width:80%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#liveSessionLayout .el-date-editor.el-input{width:100%}", ""]);
// Exports
module.exports = exports;
